import { readLastAuthError } from '@/lib/bootstrapError'
import { AppErrorScreen } from '@/app/AppErrorScreen'
import '@/shared/styles/global.css'
import { clearAuthAttempts } from '@/app/authAttempts'

// Attempt-breaker screen. The failure that tripped the breaker happened one
// redirect round-trip ago, so no error object exists here - the persisted
// last-auth-error (if fresh) supplies the hidden diagnostic.
export const AuthError = () => (
  <AppErrorScreen
    title="Sign-in failed"
    message="Sign-in failed repeatedly - please retry."
    stage="signin-loop"
    error={readLastAuthError() ?? undefined}
    action={{ label: 'Retry', onClick: () => { clearAuthAttempts(); window.location.replace('/') } }}
  />
)

